import { Footer } from '@/components/Footer'
import { NavBar } from '@/components/nav-bar'

export const PrivacyPolicy = () => {
  return (
    <div className="overflow-hidden h-full noScrollbar w-full">
      <NavBar />
      <div className="max-w-3xl mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-sm text-gray-600 mb-6">Last Updated: April 1, 2025</p>

        <p className="mb-4">
          This Privacy Notice for <strong>DB8AI.com</strong> (a product of Symbollogic LLC) (“
          <strong>we</strong>,” “<strong>us</strong>,” or “<strong>our</strong>”) describes how and
          why we might access, collect, store, use, and/or share (“<strong>process</strong>”) your
          personal information when you use our services (“<strong>Services</strong>”), including
          when you:
        </p>

        <ul className="list-disc list-inside mb-4">
          <li>
            Visit our website at <strong>db8ai.com</strong> or any website of ours that links to
            this notice
          </li>
          {/* <li>Download and use our mobile app</li> */}
          <li>Engage with us in other related ways, including sales, marketing, or events</li>
        </ul>

        <p className="mb-4">
          If you do not agree with our policies and practices, please do not use our Services.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. What Information Do We Collect?</h2>
        <p className="mb-4">
          We collect personal information you voluntarily provide such as your name, email,
          usernames, and billing address. We may also collect usage data, mobile permissions (like
          camera/microphone), and push notification preferences.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How Do We Process Your Information?</h2>
        <p className="mb-4">
          We process your information to operate, improve, and secure our services, and comply with
          the law. This includes account management, communication, and fraud prevention.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          3. When and With Whom Do We Share Personal Information?
        </h2>
        <p className="mb-4">
          We may share information with service providers like Paddle (our payment processor) to
          fulfill transactions. We do not sell your personal information.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
        <p className="mb-4">
          We use organizational and technical safeguards to protect your information, though no
          online system is 100% secure.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
        <p className="mb-4">
          Depending on your location, you may request access, correction, or deletion of your
          personal data by contacting us.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Google API Data</h2>
        <p className="mb-4">
          Our use of Google APIs complies with the{' '}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            className="text-blue-600 underline"
            target="_blank"
          >
            Google API Services User Data Policy
          </a>
          .
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact</h2>
        <p className="mb-2">For privacy questions or requests, please contact us at:</p>
        <p className="mb-8">
          📧{' '}
          <a href="mailto:support@symbollogic.com" className="text-blue-600 underline">
            support@symbollogic.com
          </a>
        </p>
      </div>
      <Footer />
    </div>
  )
}
